export class Callback {
  name: string;
  email: string;
  company: string;
  phone: string;
  preferredHour: string;
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/callback.ts